<div class="tour-container">
  @for (step of tourSteps$ | async; track step) {
    <rcp-tour-step-display
      [id]="step.id"
      [attachToElement]="step.attachToElement"
      [position]="step.position"
      [sticky]="step.sticky"
    >
      <ng-container [ngTemplateOutlet]="step.contentTemplate"></ng-container>
    </rcp-tour-step-display>
  }
</div>
